import { render, staticRenderFns } from "./RiskControlLayer.vue?vue&type=template&id=0e99771f&scoped=true&"
import script from "./RiskControlLayer.vue?vue&type=script&lang=js&"
export * from "./RiskControlLayer.vue?vue&type=script&lang=js&"
import style0 from "./RiskControlLayer.vue?vue&type=style&index=0&id=0e99771f&prod&lang=scss&scoped=true&"
import style1 from "./RiskControlLayer.vue?vue&type=style&index=1&id=0e99771f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99771f",
  null
  
)

export default component.exports